import { useCallback, useEffect, useMemo, useState } from "react";
import { DEFAULT_TITLE_SORT, TITLE_SORT_STORAGE_PREFIX, nextTitleSort, parseStoredTitleSort, resolveTitleSort, } from "../utils/titleSort";
var readStoredRaw = function (storageKey) {
    try {
        return sessionStorage.getItem(storageKey);
    }
    catch (_a) {
        return null;
    }
};
export var useTitleSort = function (key, allowedKeys, defaultSort) {
    if (defaultSort === void 0) { defaultSort = DEFAULT_TITLE_SORT; }
    var storageKey = "".concat(TITLE_SORT_STORAGE_PREFIX).concat(key);
    var allowedSignature = allowedKeys.join("\n");
    var defaultSortBy = defaultSort.sortBy, defaultSortDir = defaultSort.sortDir;
    var resolve = useCallback(function (candidate) {
        return resolveTitleSort(candidate, allowedSignature ? allowedSignature.split("\n") : [], { sortBy: defaultSortBy, sortDir: defaultSortDir });
    }, [allowedSignature, defaultSortBy, defaultSortDir]);
    var readStored = function () { return ({
        storageKey: storageKey,
        sort: parseStoredTitleSort(readStoredRaw(storageKey), allowedKeys, defaultSort),
    }); };
    var _a = useState(readStored), stored = _a[0], setStored = _a[1];
    if (stored.storageKey !== storageKey) {
        setStored(readStored());
    }
    var sort = useMemo(function () { return resolve(stored.sort); }, [resolve, stored.sort]);
    useEffect(function () {
        sessionStorage.setItem(storageKey, JSON.stringify(sort));
    }, [storageKey, sort]);
    var handleSort = useCallback(function (sortBy) {
        return setStored(function (prev) { return ({
            storageKey: prev.storageKey,
            sort: nextTitleSort(resolve(prev.sort), sortBy),
        }); });
    }, [resolve]);
    return { sort: sort, handleSort: handleSort };
};
